var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '../../utils/cn';
var cls = classNames('next-page-link');
import { breakpoints, theme } from '@shapeable/theme';
import { IconLink } from './icon-link';
import { Icons } from '../icons';
import { OutlineNumber } from './outline-number';
import { SectionTitle } from './section-title';
import { useLinearNavigation } from '../../hooks/use-linear-navigation';
export var NextPageLinkDefaultProps = {
  label: 'Next Page:'
}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    a {\n      text-decoration: none;\n    }\n  "], ["\n    a {\n      text-decoration: none;\n    }\n  "])))
});
var LinkStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: 1em;\n    align-items: center;\n  "], ["\n    font-size: 1em;\n    align-items: center;\n  "])))
});
var LabelStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin-bottom: 0;\n    top: -1px;\n    position: relative;\n  "], ["\n    margin-bottom: 0;\n    top: -1px;\n    position: relative;\n  "])))
});
var OutlineNumberStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin-right: ", ";\n  "], ["\n    margin-right: ", ";\n  "])), theme.UNIT(2))
});
var BodyStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: flex;\n    min-height: 56px;\n    flex-direction: row;\n    align-items: center;\n  "], ["\n    display: flex;\n    min-height: 56px;\n    flex-direction: row;\n    align-items: center;\n  "])))
}); // -------- Components -------->

var My = {
  Container: styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Link: styled(IconLink)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), LinkStyles),
  Body: styled.span.attrs(cls.attr('body'))(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Label: styled(SectionTitle)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  OutlineNumber: styled(OutlineNumber)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), OutlineNumberStyles)
};
export var NextPageLink = function NextPageLink(props) {
  var className = props.className,
      children = props.children,
      label = props.label;

  var _a = useLinearNavigation(),
      next = _a.next,
      hasNext = _a.hasNext;

  if (!hasNext) {
    return null;
  }

  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Label, null, label), React.createElement(My.Link, {
    color: next.color && next.color.value,
    href: next.path,
    icon: React.createElement(Icons.ChevronRight, null),
    iconSize: 16
  }, React.createElement(My.Body, null, next.outlineNumber && React.createElement(My.OutlineNumber, {
    size: "link",
    showBorder: true,
    color: next.color
  }, next.outlineNumber), children || next.name)));
};
NextPageLink.defaultProps = NextPageLinkDefaultProps;
NextPageLink.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;